import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import SignIn from '@/views/SignIn.vue';
import SignUp from '@/views/SignUp.vue';
import Horses from '@/views/Horses/Horses.vue';
import Horse from '@/views/Horses/Horse.vue';
import HorseHealth from '@/views/Horses/HorseHealth.vue';
import HorseTrainings from '@/views/Horses/HorseTrainings.vue';
import HorseDiets from '@/views/Horses/HorseDiets.vue';
import HorseWeights from '@/views/Horses/HorseWeights.vue';
import HorseVaccins from '@/views/Horses/HorseVaccins.vue';
import HorseTreatments from '@/views/Horses/HorseTreatments.vue';
import HorseExams from '@/views/Horses/HorseExams.vue';
import HorseHealthProblems from '@/views/Horses/HorseHealthProblems.vue';
import Soci from '@/views/Soci.vue';
import FarrierHorses from '../views/Horses/FarrierHorses.vue';
import CustomerHorses from '../views/Horses/CustomerHorses.vue';
import GroomHorses from '../views/Horses/GroomHorses.vue';
import InstructorHorses from '../views/Horses/InstructorHorses.vue';
import StableManagerHorses from '../views/Horses/StableManagerHorses.vue';
import VeterinarianHorses from '../views/Horses/VeterinarianHorses.vue';
import HorseStablesMain from '@/views/HorseStables/HorseStablesMain';
import HorseStables from '@/views/HorseStables/HorseStables';
import HorseStablesBoxes from '@/views/HorseStables/HorseStablesBoxes';
import Notifications from '../views/Users/Notifications.vue';
import store from '@/store';
import Lessons from "../views/lessons/Lessons.vue";
import Lesson from "../views/lessons/Lesson.vue";
import LessonCalendar from "../views/lessons/LessonCalendar.vue";


const routes = [
	{
		path: '/',
		name: '/',
		redirect: '/dashboard',
		meta: { requiresAuth: true },
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		meta: { requiresAuth: true },
	},
	{
		path: '/horses',
		name: 'Horses',
		component: Horses,
		meta: { requiresAuth: true },
	},
  {
    path: "/lessons",
    name: "Lessons",
    component: Lessons,
    meta: { requiresAuth: true },
  },
  {
    path: "/lesson/add",
    name: "LessonAdd",
    component: Lesson,
    props: true,
  },
  {
    path: "/lessons/calendar",
    name: "LessonCalendar",
    component: LessonCalendar,
    props: true,
  },
  {
    path: "/lessons/:id/:action?",
    name: "Lesson",
    component: Lesson,
    props: true, // Passa il parametro id come prop al componente
  },
  // {
  //   path: "/lessons/calendar",
  //   name: "LessonCalendar",
  //   component: LessonCalendar,
  //   props: true,
  // },
	{
		path: '/customer-horses',
		name: 'CustomerHorses',
		component: CustomerHorses,
		meta: { requiresAuth: true },
	},
	{
		path: '/farrier-horses',
		name: 'FarrierHorses',
		component: FarrierHorses,
		meta: { requiresAuth: true },
	},
	{
		path: '/groom-horses',
		name: 'GroomHorses',
		component: GroomHorses,
		meta: { requiresAuth: true },
	},
	{
		path: '/instructor-horses',
		name: 'InstructorHorses',
		component: InstructorHorses,
		meta: { requiresAuth: true },
	},
	{
		path: '/notifications',
		name: 'Notifications',
		component: Notifications,
		meta: { requiresAuth: true },
	},
	{
		path: '/stable-manager-horses',
		name: 'StableManagerHorses',
		component: StableManagerHorses,
		meta: { requiresAuth: true },
	},
	{
		path: '/veterinarian-horses',
		name: 'VeterinarianHorses',
		component: VeterinarianHorses,
		meta: { requiresAuth: true },
	},
	{
		path: "/horse/add",
		name: "HorseAdd",
		component: Horse,
		props: true, // Passa il parametro id come prop al componente
	},
	{
		path: "/horses/:id/:action?",
		name: "Horse",
		component: Horse,
		props: true, // Passa il parametro id come prop al componente
	},
	{
		path: '/horseHealth/:id',
		name: 'HorseHealth',
		component: HorseHealth,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseDiets/:id',
		name: 'HorseDiets',
		component: HorseDiets,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseTrainings/:id',
		name: 'HorseTrainings',
		component: HorseTrainings,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseWeights/:id',
		name: 'HorseWeights',
		component: HorseWeights,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseVaccins/:id',
		name: 'HorseVaccins',
		component: HorseVaccins,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseTreatments/:id',
		name: 'HorseTreatments',
		component: HorseTreatments,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseExams/:id',
		name: 'HorseExams',
		component: HorseExams,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/horseHealthProblems/:id',
		name: 'HorseHealthProblems',
		component: HorseHealthProblems,
		meta: { requiresAuth: true },
		props: true,
	},
	{
		path: '/soci',
		name: 'Soci',
		component: Soci,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			const user = store.state.user;

			if (user && !!user.riding_stables.length) {
				next();
			} else {
				next('/');
			}
		},
	},
	{
		path: '/maneggio',
		name: 'Maneggio',
		component: HorseStablesMain,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			const user = store.state.user;

			if (user && !!user.riding_stables.length) {
				next();
			} else {
				next('/');
			}
		},
	},
	{
		path: '/scuderie',
		name: 'Scuderie',
		component: HorseStables,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			const user = store.state.user;

			if (user && !!user.riding_stables.length) {
				next();
			} else {
				next('/');
			}
		},
	},
	{
		path: '/scuderie/:id',
		name: 'Box',
		component: HorseStablesBoxes,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			const user = store.state.user;

			if (user && !!user.riding_stables.length) {
				next();
			} else {
				next('/');
			}
		},
		props: (route) => ({ horseStable_id: route.params.id }),
	},
	{
		path: '/sign-in',
		name: 'Sign In',
		component: SignIn,
	},
	{
		path: '/sign-up',
		name: 'Sign Up',
		component: SignUp,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	linkActiveClass: 'active',
});

router.beforeEach((to, from, next) => {
	const isAuthenticated = !!localStorage.getItem("authToken");

	if (to.meta.requiresAuth && !isAuthenticated) {
		next('/sign-in'); // Redirect to login if user is not authenticated
	} else {
		next(); // Proceed to the route
	}
});

export default router;
